import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { ClipBoardService } from '../../../services/clipboard.service';
import { ServerService } from '../../../services/server.service';
import { LeadVndorUpdatedModalComponent } from '../../client-master-lead/lead-vendor-updated-modal/lead-vendor-updated-modal.component';
import { LeadUpdatedToVerifiedStatusModalComponent } from '../../client-master-lead/lead-updated-to-verified-status-modal/lead-updated-to-verified-status-modal.component';
import { Device } from 'twilio-client';
//import { Device } from '@twilio/voice-sdk';
import { ClientLeadEmailCreateModalComponent } from '../../client-lead-profile/client-lead-email-create-modal/client-lead-email-create-modal.component';
import { ClientLeadProfileTaskCreateModalComponent } from '../../client-lead-profile/client-lead-profile-task-create-modal/client-lead-profile-task-create-modal.component';
import { RegistrationCreateModalComponent } from '../../registration-list/registration-create-modal/registration-create-modal.component';
import { AdminClientProjectModalComponent } from '../admin-client-project-modal/admin-client-project-modal.component';
import { AdminProjectModalComponent } from '../admin-project-modal/admin-project-modal.component';
import { AppointmentModalComponent } from '../appointment-modal/appointment-modal.component';
import { CallsListModalComponent } from '../calls-list-modal/calls-list-modal.component';
import { ClientAssignLeadModalComponent } from '../client-assign-lead-modal/client-assign-lead-modal.component';
import { ClientExportLeadModalComponent } from '../client-export-lead-modal/client-export-lead-modal.component';
import { ClientLeadCreateModalComponent } from '../client-lead-create-modal/client-lead-create-modal.component';
import { ClientLeadDeleteModalComponent } from '../client-lead-delete-modal/client-lead-delete-modal.component';
import { ClientLeadEditModalComponent } from '../client-lead-edit-modal/client-lead-edit-modal.component';
import { ClientLeadFilterModalComponent } from '../client-lead-filter-modal/client-lead-filter-modal.component';
import { ClientLeadInfoModalComponent } from '../client-lead-info-modal/client-lead-info-modal.component';
import { ClientLeadTransferModalComponent } from '../client-lead-transfer-modal/client-lead-transfer-modal.component';
import { ClientLeadWebhookCreateModalComponent } from '../client-lead-webhook-create-modal/client-lead-webhook-create-modal.component';
import { ClientRemarkModalComponent } from '../client-remark-modal/client-remark-modal.component';
import { ClientUploadModalComponent } from '../client-upload-modal/client-upload-modal.component';
import { ConfirmLeadModalComponent } from '../confirm-lead-modal/confirm-lead-modal.component';
import { CopyLeadModalComponent } from '../copy-lead-modal/copy-lead-modal.component';
import { CopyMultipleLeadModalComponent } from '../copy-multiple-lead-modal/copy-multiple-lead-modal.component';
import { SetLeadColorModalComponent } from '../set-lead-color-modal/set-lead-color-modal.component';

@Component({
  selector: 'app-make-call-clone',
  templateUrl: './make-call-clone.component.html',
  styleUrls: ['./make-call-clone.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MakeCallCloneComponent implements OnInit {

  userInfo: any = JSON.parse(localStorage.getItem("userInfo"));
  authToken: any = localStorage.getItem("token");
  lead: any = {};
  verifiedForm = false;
  startCallBtn: any = false
  makeCallAction: FormGroup;
  action = "";
  muteLeadCall = false
  appointmentForm = false;
  notInterestedForm = false;
  callMessage: string = 'Calling...';
  callStatus: boolean = false;
  calling_object: any
  selectedReason2 = false
  // const token = 'YOUR_OBTAINED_TOKEN'; // Replace with the actual token you received from the backend
  calling_token: any
  device: any;
  phoneNumber = '+918840227019';
  // const device = new Device(token);
  // const phoneNumber = 'PHONE_NUMBER_TO_DIAL'; // Replace with the phone number you want to call
  // device.connect({ phoneNumber });
  showSuggestion: boolean = false
  autoRemark: any[] = []
  selectedStatus: any
  suggestions = [
      {
          "status": "Not Interested",
          "values": [
              "Low Budget",
              "Not Looking for property",
              "Looking into other area",
              "Looking for Under Construction",
              "Looking for Ready to Move",
              "Loan Eligibility Issue",
              "Already purchased",
              "Looking for well know builder",
              "Looking for other builder",
              "Did not enquired"
          ]
      },
      {
          "status": "Follow Up",
          "values": [
              "Details sent",
              "Will do booking",
              "Will callback myself",
              "Site visit planned",
              "Negotiating",
              "Discuss with family or friend",
              "Inventory Issue",
              "Plan dropped",
              "Interested in resale",
              "Legal Issue"
          ]
      },
      {
          "status": "Contacted",
          "values": [
              "Call after sometime",
          ]
      },
      {
          "status": "Site Visit",
          "values": [
              "Negotiation",
              "Will do booking",
              "Inventory issue",
              "Location Issue",
              "Project Issue",
              "Legal Issue",
              "Visit again",
              "Interested in resale",
              "Plan dropped"
          ]
      },
      {
          "status": "Closed/Won",
          "values": [
              "Details of purchased unit",
          ]
      },
      {
          "status": "Interested",
          "values": [
              "Interested but Call after sometime",
              "Will callback myself",
              "Plan dropped"
          ]
      },
  ]
  showRemark: boolean = false
  leadVndorUpdatedModalComponent: MatDialogRef<LeadVndorUpdatedModalComponent>
  leadUpdatedToVerifiedStatusModalComponent: MatDialogRef<LeadUpdatedToVerifiedStatusModalComponent>

  leadCreateModalComponent: MatDialogRef<ClientLeadCreateModalComponent>;
  leadFilterModalComponent: MatDialogRef<ClientLeadFilterModalComponent>;
  leadInfoModalComponent: MatDialogRef<ClientLeadInfoModalComponent>;
  leadEditModalComponent: MatDialogRef<ClientLeadEditModalComponent>;
  clientRemarkModalComponent: MatDialogRef<ClientRemarkModalComponent>;
  uploadModalComponent: MatDialogRef<ClientUploadModalComponent>
  clientExportLeadModalComponent: MatDialogRef<ClientExportLeadModalComponent>;
  clientLeadDeleteModalComponent: MatDialogRef<ClientLeadDeleteModalComponent>;
  leadWebhookCreateModalComponent: MatDialogRef<ClientLeadWebhookCreateModalComponent>;
  clientAssignLeadModalComponent: MatDialogRef<ClientAssignLeadModalComponent>;
  clientLeadTransferModalComponent: MatDialogRef<ClientLeadTransferModalComponent>
  ClientLeadProfileTaskCreateModalComponent: MatDialogRef<ClientLeadProfileTaskCreateModalComponent>
  clientLeadEmailCreateModalComponent: MatDialogRef<ClientLeadEmailCreateModalComponent>
  setLeadColorModalComponent: MatDialogRef<SetLeadColorModalComponent>
  appointmentModalComponent: MatDialogRef<AppointmentModalComponent>
  copyLeadModalComponent: MatDialogRef<CopyLeadModalComponent>
  callsListModalComponent: MatDialogRef<CallsListModalComponent>
  copyMultipleLeadModalComponent: MatDialogRef<CopyMultipleLeadModalComponent>
  adminProjectModalComponent: MatDialogRef<AdminProjectModalComponent>
  clientLeadWebhookCreateModalComponent: MatDialogRef<ClientLeadWebhookCreateModalComponent>
  confirmLeadModalComponent: MatDialogRef<ConfirmLeadModalComponent>
  adminClientProjectModalComponent: MatDialogRef<AdminClientProjectModalComponent>
  registrationCreateModalComponent: MatDialogRef<RegistrationCreateModalComponent>


  userId;
  leadId;
  leadContactNumber;
  defaultPhoneNumber;

  callStart: any = true;
  callEnd: any = false;
  mute: any = true;
  unMute: any = false;

  leadStatusText: any = "";

  showLeadStatusForm: boolean = true;
  showVerifiedForm: boolean = false;
  showAppointmentForm: boolean = false;
  showTaskForm: boolean = false;
  showNotInterstedForm: boolean = false;
  showConfirmForm: boolean = false;

  leadVerified!: FormGroup;
  leadAppointment!: FormGroup;
  leadTaskForm!: FormGroup;
  notInterstedForm!: FormGroup;
  remarkOnly!: FormGroup;

  selectedInventory: any;
  getCurrentdateTime: Date = new Date();

  btnStatus: boolean = false;

  callSId: any;

  leadInfo: any = JSON.parse(localStorage.getItem("leadInfo"))

  appointmentHideTask = false;
  hideTask = false;
  hideLocationDetail = false;

  isClose: boolean = true;

  waitBtn: boolean = false

  callerForm: FormGroup;
  defaultcallerNumber: any;
  callerIDList: any;

  showComponentLoader: boolean = false

  prioritycallerList: any = []

  constructor(
      public clipBoardService: ClipBoardService,
      private fb: FormBuilder,
      private serverService: ServerService,
      private router: Router,
      private dialog: MatDialog,
      private dialogRef: MatDialogRef<MakeCallCloneComponent>,
      private snackBar: MatSnackBar,
      @Inject(MAT_DIALOG_DATA) public data) {
      this.lead = data
      //console.log(data)
      this.leadStatusText=this.lead.lead_status
      if (this.lead.lead_status != "Verified" && this.lead.lead_status != "V Not Interested") {
          this.showRemark = true
      }
      //this.getAllCallerIds()
  }

  ngOnInit() {
      this.setCallerForm()
      //this.getAllCallerIds()
      this.setLeadVerified();
      this.setAppointment();
      this.setTask();
      this.setRemark();
      this.setNotIntersted();     
      
      
    if (this.lead.lead_status == 'Appointment Proposed') {
        this.showAppointmentForm = true;
        //this.patchAppointment();
    }

    if (this.lead.lead_status == 'V Not Responding' || this.lead.lead_status == 'V Interested' || this.lead.lead_status == 'V Follow Up' || this.lead.lead_status == 'V SV Drop' || this.lead.lead_status == 'V SV Done' || this.lead.lead_status == 'V Booking done' || this.lead.lead_status == 'V Not Available' || this.lead.lead_status == 'Callback' || this.lead.lead_status == 'Wrong Number') {
        this.showTaskForm = true;
        //this.patchTask();
    }

    if (this.lead.lead_status == 'V Not Interested') {
        this.showNotInterstedForm = true;
        //this.patchNotIntersted()
    }

    if (this.lead.lead_status == 'Interested' || this.lead.lead_status == 'Not Interested' || this.lead.lead_status == 'Not Responding' || this.lead.lead_status == 'Not Available' || this.lead.lead_status == 'Contacted' || this.lead.lead_status == 'Follow Up' || this.lead.lead_status == 'Closed/Won' || this.lead.lead_status == 'Site Visit') {
        this.showConfirmForm = true;
    }
      
    if(this.lead.lead_status != "Verified"){
    this.showVerifiedForm = false;
    }

  }

  setCallerForm() {
      this.callerForm = this.fb.group({
          callDefaultNumber: ['']
      })
  }

  callList: any = {}
  getAllCallerIds() {

      this.showComponentLoader = true

      this.serverService.getCallerId("caller_numbers", this.authToken).subscribe(data => {
          this.callerIDList = data
          //console.log(this.callerIDList)
          this.defaultcallerNumber = data.find((e: any) => {
              if (e.default_number) {
                  return e
              }
          })
          this.callerForm.controls.callDefaultNumber.patchValue(this.defaultcallerNumber.id);

          this.serverService.getAllCallsWithPriority(this.lead.id, this.authToken).subscribe(data => {
              this.callList = data
              //console.log(this.callList)

              this.callerIDList.forEach(caller => {
                  const foundEntry = this.callList.find(entry => entry.from_number === caller.phone_number);
                  if (foundEntry) {
                      this.prioritycallerList.push(foundEntry)
                      //console.log(`Call log found for caller ${caller.phone_number}:`, this.callerObj[caller.phone_number]=foundEntry);
                  }
                  // else {
                  //     console.log(`No call log found for caller ${caller.callerNumber}. not called`);
                  // }            
              });
              //console.log(this.prioritycallerList)

          }, err => {
              this.clipBoardService.checkServerError(err, this.authToken)
          }
          )

          this.showComponentLoader = false
      },
          err => {
              this.showComponentLoader = false
              this.clipBoardService.checkServerError(err, this.authToken)
          }
      )
  }


  getAllCallsWithPriority(){

      this.showComponentLoader = true

      this.serverService.getAllCallsWithPriority("prioritize_caller_number?lead_id="+this.lead.id, this.authToken).subscribe(data => {
          this.prioritycallerList = data
          //console.log(this.prioritycallerList)
          this.showComponentLoader = false
      },
          err => {
              this.showComponentLoader = false
              this.clipBoardService.checkServerError(err, this.authToken)
          }
      )
  } 

  makedefault(event: any) {

      if (!event.value) {
          return false
      }

      let body = {
          "id": event.value,
      }

      this.showComponentLoader = true

      this.serverService.makeDefaultCallerId(body, this.authToken).subscribe(data => {

          // this.serverService.getCallerId("caller_numbers", this.authToken).subscribe(data => {
          //     this.callerIDList = data
          //     this.defaultcallerNumber = data.find((e: any) => {
          //         if (e.default_number) {
          //             return e
          //         }
          //     })
          //     this.callerForm.controls.callDefaultNumber.patchValue(this.defaultcallerNumber.id);
          // }, err => {
          //     this.clipBoardService.checkServerError(err, this.authToken)
          // }
          // )

          this.getAllCallerIds()

          this.clipBoardService.showMessgeInText("Default Set Succesfully", "success-snackbar");
          this.showComponentLoader = false

      },
          err => {
              this.showComponentLoader = false
              let message = JSON.parse(err._body);
              if (err.status == 422) {
                  this.clipBoardService.showMessgeInText(JSON.stringify(message.errors), "error-snackbar");
              } else {
                  this.clipBoardService.checkServerError(err, this.authToken)
              }
          }
      )
  }

  statusChanged(value: any, loadStatus?: any) {

      this.leadStatusText = value;

      this.showVerifiedForm = false;
      this.showAppointmentForm = false;
      this.showTaskForm = false;
      this.showNotInterstedForm = false;
      this.showConfirmForm = false;

      this.appointmentHideTask = false;
      this.hideTask = false;
      this.hideLocationDetail = false;

      if (value == 'Fresh' && loadStatus != 'onload') {
          this.saveLeadFresh();
      }
      if (value == 'V Under Review') {
          this.saveLeadVUnderReview();
      }
      if (value == 'Verified') {
          this.showVerifiedForm = true;
          //this.patchLeadVerified()
      }

      if (value == 'Appointment Proposed') {
          this.showAppointmentForm = true;
          this.patchAppointment();
      }

      if (value == 'V Not Responding' || value == 'V Interested' || value == 'V Follow Up' || value == 'V SV Drop' || value == 'V SV Done' || value == 'V Booking done' || value == 'V Not Available' || value == 'Callback' || value == 'Wrong Number') {
          this.showTaskForm = true;
          this.patchTask();
      }

      if (value == 'V Not Interested') {
          this.showNotInterstedForm = true;
          //this.patchNotIntersted()
      }

      if (value == 'Interested' || value == 'Not Interested' || value == 'Not Responding' || value == 'Not Available' || value == 'Contacted' || value == 'Follow Up' || value == 'Closed/Won' || value == 'Site Visit') {
          this.showConfirmForm = true;
      }


  }

  //fresh
  saveLeadFresh() {

      let remarkBody = {};
      remarkBody["lead_status"] = this.leadStatusText;
      remarkBody["vendor_remark"] = this.lead.vendor_remark;
      remarkBody["vendor_remark_new"] = this.lead.vendor_remark;

      let freshBody = {}
      freshBody["after_call_lead_status"] = this.leadStatusText;
      freshBody["after_call_lead_remark"] = this.lead.vendor_remark;


      this.serverService.updateLead(this.lead, remarkBody, this.authToken).subscribe(data => {
          this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")
          this.dialogRef.close(freshBody);
      }, err => {
          this.btnStatus = true
          this.clipBoardService.checkServerError(err, this.authToken)
      })

  }

  saveLeadVUnderReview() {

      let remark = {
          "lead_status": this.leadStatusText,
          "after_call_lead_status": this.leadStatusText,
          "vendor_remark": this.lead.vendor_remark,
          "vendor_remark_new": this.lead.vendor_remark
      };
      // let remarkBody = {};
      // remarkBody["lead_status"] = this.leadStatusText;
      // remarkBody["vendor_remark"] = this.lead.vendor_remark;
      // remarkBody["vendor_remark_new"] = this.lead.vendor_remark;

      this.serverService.updateLead(this.lead, remark, this.authToken).subscribe(data => {
          // console.log(data)
          this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")
          this.dialogRef.close(remark);
      }, err => {
          this.btnStatus = true
          this.clipBoardService.checkServerError(err, this.authToken)
      })

  }

  // verified
  setLeadVerified() {
      this.leadVerified = this.fb.group({
          budget: ['', Validators.required],
          possession: ['', Validators.required],
          inventory: ['', Validators.required],
          remark: [''],
          location: this.fb.array([this.setAddress()]),
      })
  }

  setAddress() {
      return this.fb.group({
          address: ['']
      })
  }

  get addressArr(): any {
      return this.leadVerified.get('location') as FormArray;
  }

  addAddress() {
      this.addressArr.push(this.setAddress())
  }

  removeAddress(i: any) {
      this.addressArr.removeAt(i)
  }

  patchLeadVerified() {
      //this.leadVerified.controls['budget'].patchValue('10L-30L');
      //this.leadVerified.controls['possession'].patchValue(this.lead.Possession);
      //this.leadVerified.controls['remark'].patchValue(this.lead.vendor_remark_new);
      //this.leadVerified.controls['description'].patchValue("Lead Id:" + this.lead.id + "\n" + "Name : " + this.lead.name + "\n" + "Email:" + this.lead.email + "\n" + "Phone:" + this.lead.phone);
  }

  addressArrSplit: any = []
  saveLeadVerified() {

      if (this.leadVerified.invalid) {
          return false;
      }

      this.btnStatus = true

      this.leadVerified.value.location.forEach((item: any) => {
          this.addressArrSplit.push(item.address)
      })

      let budgetBody = {
          "id": this.lead.id,
          //"preferred_location": this.leadVerified.value.location,
          "preferred_location": this.addressArrSplit,
          "possession": "31-12-" + this.leadVerified.value.possession,
          "budget": this.leadVerified.value.budget,
          "tags": this.leadVerified.value.inventory
      }


      this.serverService.updateLeadPrefLocBudget(budgetBody, this.authToken).subscribe(data1 => {
          //this.clipBoardService.showMessgeInText("Your query has been submitted", "success-snackbar")
          //this.btnStatus = false
          let remarkBody = {};
          remarkBody["lead_status"] = this.leadStatusText;
          remarkBody["vendor_remark"] = this.leadVerified.value.remark;
          remarkBody["vendor_remark_new"] = this.leadVerified.value.remark;
          this.serverService.updateLead(this.lead, remarkBody, this.authToken).subscribe(data2 => {
              //this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")

              let callRecordBody = {
                  "lead_id": this.lead.id,
                  //"call_sid": this.callSId,
                  "after_call_lead_status": this.leadStatusText,
                  "after_call_lead_remark": this.leadVerified.value.remark,
                  "before_call_lead_status": this.lead.lead_status
              }

              this.serverService.callRecordManual(callRecordBody, this.authToken).subscribe(data3 => {
                  this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")
                  this.btnStatus = false
                  //this.showVerifiedForm = false
                  this.dialogRef.close(data3);
              }, err => {
                  this.clipBoardService.checkServerError(err, this.authToken)
              })


          }, err => {
              this.clipBoardService.checkServerError(err, this.authToken)
          }

          )
      }, err => {
          this.btnStatus = true
          this.clipBoardService.checkServerError(err, this.authToken)
      }
      )
  }

  // appointment
  setAppointment() {
      this.leadAppointment = this.fb.group({
          dateTime: ['', Validators.required],
          remark: ['', Validators.required],
          category: ['Call'],
          priority: ['1'],
          subject: [''],
          description: [''],
          autoReminder: [true],
          customRemainder: [],
          dueDate: [''],
      })
  }

  patchAppointment() {

      if (this.lead.vendor_appointment_date != null) {
          this.leadAppointment.controls['dateTime'].patchValue(this.lead.vendor_appointment_date);
      } else {
          this.leadAppointment.controls['dateTime'].patchValue(this.getCurrentdateTime);
      }

      if (this.userInfo.member_type == 'Vendor') {
          this.leadAppointment.controls['remark'].patchValue(this.lead.vendor_remark);
      } else if (this.userInfo.member_type == 'Client') {
          this.leadAppointment.controls['remark'].patchValue(this.lead.client_remark);
      }

      this.leadAppointment.controls['dueDate'].patchValue(this.getCurrentdateTime);
      this.leadAppointment.controls['customRemainder'].patchValue(this.getCurrentdateTime);
      this.leadAppointment.controls['subject'].patchValue('Reminder - ' + this.lead.project.name + '-' + this.lead.lead_status);
      this.leadAppointment.controls['description'].patchValue("Lead Id:" + this.lead.id + "\n" + "Name : " + this.lead.name + "\n" + "Email:" + this.lead.email + "\n" + "Phone:" + this.lead.phone);
  }

  taskAppointmentModalShow() {

      this.appointmentHideTask = !this.appointmentHideTask;

      if (this.appointmentHideTask) {
          this.leadAppointment.controls["category"].setValidators([Validators.required]);
          this.leadAppointment.controls["priority"].setValidators([Validators.required]);
          this.leadAppointment.controls["subject"].setValidators([Validators.required]);
      } else {
          this.leadAppointment.controls["category"].setValidators([]);
          this.leadAppointment.controls["priority"].setValidators([]);
          this.leadAppointment.controls["subject"].setValidators([]);
      }
      this.leadAppointment.controls["category"].updateValueAndValidity();
      this.leadAppointment.controls["priority"].updateValueAndValidity();
      this.leadAppointment.controls["subject"].updateValueAndValidity();

  }

  saveAppointment() {

      if (this.leadAppointment.invalid) {
          return false;
      }

      this.btnStatus = true

      if (this.appointmentHideTask) {
          this.taskAppointmentSubmit()
          this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
          this.btnStatus = false
      } else {
          this.updateLeadSubmit()
          this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
          this.btnStatus = false
      }

  }

  taskAppointmentSubmit() {

      let body = {
          "task_category": this.leadAppointment.value.category,
          "subject": this.leadAppointment.value.subject,
          "priority": this.leadAppointment.value.priority,
          "description": this.leadAppointment.value.description,
          "due_date": this.leadAppointment.value.dueDate.toJSON(),
          "auto_reminder": this.leadAppointment.value.autoReminder,
          "custom_reminder": this.leadAppointment.value.customRemainder.toJSON(),
          "lead_id": this.lead.id
      }

      this.serverService.createLeadTask(body, this.authToken).subscribe(data => {
          //this.clipBoardService.showMessgeInText("Appointment Updated Successfully", "success-snackbar")            
          this.updateLeadSubmit()
      }, err => {
          this.clipBoardService.checkServerError(err, this.authToken)
      })
  }

  updateLeadSubmit() {

      let body;

      if (this.userInfo.member_type == 'Vendor') {
          body = {
              "lead_status": this.leadStatusText,
              "vendor_appointment_date": this.leadAppointment.value.dateTime,
              "vendor_remark": this.leadAppointment.value.remark,
              "vendor_remark_new": this.leadAppointment.value.remark
          };
      }

      if (this.userInfo.member_type == 'Client') {
          body = {
              "lead_status": this.leadStatusText,
              "vendor_appointment_date": this.leadAppointment.value.dateTime,
              "client_remark": this.leadAppointment.value.remark,
              "client_remark_new": this.leadAppointment.value.remark
          };
      }

      this.serverService.updateLead(this.lead, body, this.authToken).subscribe(data => {
          //this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")
          this.showAppointmentForm = false;
          this.sIDSave(this.leadAppointment.value.remark)
        //   if (this.callSId) {
        //       this.sIDSave(this.leadAppointment.value.remark)
        //   }
          //this.dialogRef.close(data);
      }, err => {
          this.btnStatus = false
          this.clipBoardService.checkServerError(err, this.authToken)
      })
  }

  callbackUpdateLeadSubmit() {

      let body;

      if (this.userInfo.member_type == 'Vendor') {
          body = {
              "lead_status": this.leadStatusText,
              //"vendor_appointment_date": this.leadAppointment.value.dateTime,
              "vendor_remark": this.remarkOnly.value.remark,
              "vendor_remark_new": this.remarkOnly.value.remark
          };
      }

      if (this.userInfo.member_type == 'Client') {
          body = {
              "lead_status": this.leadStatusText,
              //"vendor_appointment_date": this.leadAppointment.value.dateTime,
              "client_remark": this.remarkOnly.value.remark,
              "client_remark_new": this.remarkOnly.value.remark
          };
      }

      this.serverService.updateLead(this.lead, body, this.authToken).subscribe(data => {
          //this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")
          this.showAppointmentForm = false;
          this.sIDSave(this.remarkOnly.value.remark)
        //   if (this.callSId) {
        //       this.sIDSave(this.remarkOnly.value.remark)
        //   }
          //this.dialogRef.close(data);
      }, err => {
          this.btnStatus = false
          this.clipBoardService.checkServerError(err, this.authToken)
      })
  }

  // task
  setTask() {
      this.leadTaskForm = this.fb.group({
          category: ['Call'],
          priority: ['1'],
          subject: [''],
          description: [''],
          autoReminder: [true],
          dueDate: [''],
      })
  }

  patchTask() {
      this.leadTaskForm.controls['dueDate'].patchValue(this.getCurrentdateTime);
      this.leadTaskForm.controls['subject'].patchValue('Reminder - ' + this.lead.project.name + '-' + this.lead.lead_status);
      this.leadTaskForm.controls['description'].patchValue("Lead Id:" + this.lead.id + "\n" + "Name : " + this.lead.name + "\n" + "Email:" + this.lead.email + "\n" + "Phone:" + this.lead.phone);
  }

  taskModalShow() {

      this.hideTask = !this.hideTask;

      if (this.hideTask) {
          this.leadTaskForm.controls["category"].setValidators([Validators.required]);
          this.leadTaskForm.controls["priority"].setValidators([Validators.required]);
          this.leadTaskForm.controls["subject"].setValidators([Validators.required]);
      } else {
          this.leadTaskForm.controls["category"].setValidators([]);
          this.leadTaskForm.controls["priority"].setValidators([]);
          this.leadTaskForm.controls["subject"].setValidators([]);
      }
      this.leadTaskForm.controls["category"].updateValueAndValidity();
      this.leadTaskForm.controls["priority"].updateValueAndValidity();
      this.leadTaskForm.controls["subject"].updateValueAndValidity();

  }

  saveTask() {

      if (this.leadTaskForm.invalid) {
          return false;
      }

      this.btnStatus = true

      if (this.hideTask) {
          this.taskSubmit()
          this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
          this.btnStatus = false
      } else {
          //this.updateTaskSubmit()
          this.callbackUpdateLeadSubmit()
          this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
          this.btnStatus = false
      }

  }

  taskSubmit() {

      let body = {
          "task_category": this.leadTaskForm.value.category,
          "subject": this.leadTaskForm.value.subject,
          "priority": this.leadTaskForm.value.priority,
          "description": this.leadTaskForm.value.description,
          "due_date": this.leadTaskForm.value.dueDate.toJSON(),
          "auto_reminder": this.leadTaskForm.value.autoReminder,
          "lead_id": this.lead.id
      }


      this.serverService.createLeadTask(body, this.authToken).subscribe(data => {
          //this.clipBoardService.showMessgeInText("Appointment Updated Successfully", "success-snackbar")           
          //this.updateLeadSubmit()
          this.callbackUpdateLeadSubmit()
      }, err => {
          this.clipBoardService.checkServerError(err, this.authToken)
      })

  }

  updateTaskSubmit() {

      let body;

      if (this.remarkOnly.value.remark != '') {
          body = {
              "lead_status": this.leadStatusText,
              "vendor_remark": this.remarkOnly.value.remark,
              "vendor_remark_new": this.remarkOnly.value.remark
          };
      } else {
          body = {
              "lead_status": this.leadStatusText,
          };
      }

      // if (this.userInfo.member_type == 'Vendor') {
      //     body = {
      //         "lead_status": this.leadStatusText,
      //     };            
      // }

      // if (this.userInfo.member_type == 'Client') {
      //     body = {
      //         "lead_status": this.leadStatusText,
      //     };
      // }

      this.serverService.updateLead(this.lead, body, this.authToken).subscribe(data => {
          //this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")
          this.showAppointmentForm = false;
          this.sIDSave(this.remarkOnly.value.remark)
        //   if (this.callSId) {
        //       this.sIDSave(this.remarkOnly.value.remark)
        //   }
          //this.dialogRef.close(data);
      }, err => {
          this.btnStatus = false
          this.clipBoardService.checkServerError(err, this.authToken)
      })
  }

  setRemark() {
      this.remarkOnly = this.fb.group({
          remark: [''],
      })
  }

  remarkSubmit() {
      let body = {
          //"lead_status": this.leadStatusText,
          "vendor_remark": this.remarkOnly.value.remark,
          "vendor_remark_new": this.remarkOnly.value.remark
      };
      this.serverService.updateLead(this.lead, body, this.authToken).subscribe(data => {
          //this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")
      }, err => {
          this.btnStatus = false
          this.clipBoardService.checkServerError(err, this.authToken)
      })
  }



  // not intersted
  setNotIntersted() {
      this.notInterstedForm = this.fb.group({
          notInterstedRad: ['Not Interested', Validators.required],
          remark: ['', Validators.required],
          budget: [''],
          possession: [''],
          location: this.fb.array([this.setNotAddress()]),
      })
  }

  setNotAddress() {
      return this.fb.group({
          address: ['']
      })
  }

  get notAddressArr(): any {
      return this.notInterstedForm.get('location') as FormArray;
  }

  addNotAddress() {
      this.notAddressArr.push(this.setNotAddress())
  }

  removeNotAddress(i: any) {
      this.notAddressArr.removeAt(i)
  }

  patchNotIntersted() {
      this.notInterstedForm.controls['remark'].patchValue(this.lead.vendor_remark_new);
      this.notInterstedForm.controls['possession'].patchValue(this.lead.possession);
      this.notInterstedForm.controls['location'].patchValue(this.lead.location);
  }

  selectType(val) {
      if (val == 'Mismatch') {
          this.hideLocationDetail = true;
          this.notInterstedForm.controls["possession"].setValidators([Validators.required]);
      } else {
          this.hideLocationDetail = false;
          this.notInterstedForm.controls["possession"].setValidators([]);
      }
      this.notInterstedForm.controls["possession"].updateValueAndValidity();
  }

  saveNotIntersted() {


      if (this.notInterstedForm.invalid) {
          return false;
      }

      this.btnStatus = true

      if (this.hideLocationDetail) {
          this.notInterstedSubmit()
          this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
          this.btnStatus = false
      } else {
          this.updateNotInterstedSubmit()
          this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
          this.btnStatus = false
      }

  }

  addressArrSplit2: any = []
  notInterstedSubmit() {

      this.notInterstedForm.value.location.forEach((item: any) => {
          this.addressArrSplit2.push(item.address)
      })

      let body = {
          "id": this.lead.id,
          //"preferred_location": this.notInterstedForm.value.location,
          "preferred_location": this.addressArrSplit2,
          "possession": this.notInterstedForm.value.possession,
          "budget": this.notInterstedForm.value.budget,
      }

      this.serverService.updateLeadPrefLocBudget(body, this.authToken).subscribe(data => {
          //this.clipBoardService.showMessgeInText("Appointment Updated Successfully", "success-snackbar")           
          this.updateNotInterstedSubmit()
      }, err => {
          this.clipBoardService.checkServerError(err, this.authToken)
      })

  }

  updateNotInterstedSubmit() {

      let body = {
          "lead_status": this.leadStatusText,
          "vendor_remark": this.notInterstedForm.value.remark,
          "vendor_remark_new": this.notInterstedForm.value.remark
      };

      this.serverService.updateLead(this.lead, body, this.authToken).subscribe(data => {
          //this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")
          this.showNotInterstedForm = false;
          this.sIDSave(this.notInterstedForm.value.remark)
        //   if (this.callSId) {
        //       this.sIDSave(this.notInterstedForm.value.remark)
        //   }
          //this.dialogRef.close(data);
      }, err => {
          this.btnStatus = false
          this.clipBoardService.checkServerError(err, this.authToken)
      })
  }



  // confirm
  saveConfirmSubmit() {

      let body = {
          "lead_status": this.leadStatusText,
      };

      this.serverService.updateLead(this.lead, body, this.authToken).subscribe(data => {
          //this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")
          this.showConfirmForm = false;
          this.sIDSave(this.notInterstedForm.value.remark)
          this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
        //   if (this.callSId) {
        //       this.sIDSave(this.notInterstedForm.value.remark)
        //       this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
        //       //this.dialogRef.close(data);
        //   }
      }, err => {
          this.btnStatus = false
          this.clipBoardService.checkServerError(err, this.authToken)
      })
  }




  sIDSave(remark) {

      let callRecordBody = {
          "lead_id": this.lead.id,
          //"call_sid": this.callSId,
          "after_call_lead_status": this.leadStatusText,
          "after_call_lead_remark": remark,
          "before_call_lead_status": this.lead.lead_status
      }

      this.serverService.callRecordManual(callRecordBody, this.authToken).subscribe(data => {
          //this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")
          //this.btnStatus = false
          //this.showVerifiedForm = false
          // if(this.device){
          //     delete this.device;
          // }
          this.dialogRef.close(data);
      }, err => {
          this.clipBoardService.checkServerError(err, this.authToken)
      })
  }


  getCallingToken() {
      this.waitBtn = true;
      this.callStart = false;
      this.calling_object = this.device.connect({ 'From': this.defaultcallerNumber.phone_number, 'To': this.leadContactNumber, 'lead_id': this.leadId, 'user_id': this.userId }, this.callStatus = true)
      // if(!this.calling_object){
      //     this.calling_object = this.device.connect({ 'From': this.defaultPhoneNumber, 'To': this.leadContactNumber, 'lead_id': this.leadId, 'user_id': this.userId }, this.callStatus = true)
      // }
  }

  disconnectCall() {
      this.waitBtn = false
      this.device.disconnectAll();
      // if(this.device){
      //     delete this.device;
      // }
      //console.log('Update the UI to show that the call has disconnect.')
  }

  close() {
      this.waitBtn = false
      //this.device.disconnectAll();
      // if(this.device){
      //     this.device.disconnectAll();
      //     delete this.device;
      // }
      this.dialogRef.close();
  }

  muteCall() {
      this.device.activeConnection().mute(true);
      this.mute = false;
      this.unMute = true;
      //console.log('Update the UI to show that the call has mute.')
  }

  unMuteCall() {
      this.device.activeConnection().mute(false);
      this.mute = true;
      this.unMute = false;
      //console.log('Update the UI to show that the call has unmute.')
  }


  updateLeadStatus(element, event) {

      sessionStorage.setItem('lead_status_changed', 'true');
      localStorage.setItem('leadInfo', JSON.stringify(element));

      if (element.lead_status == 'V Not Responding' ||
          element.lead_status == 'V Interested' ||
          element.lead_status == 'V Follow Up' ||
          element.lead_status == 'V SV Drop' ||
          element.lead_status == 'V SV Done' ||
          element.lead_status == 'V Booking done' ||
          element.lead_status == 'V Not Available' ||
          element.lead_status == 'Callback' ||
          element.lead_status == 'Wrong Number'

          && (this.userInfo.member_type == 'Vendor')) {
          this.ClientLeadProfileTaskCreateModalComponent = this.dialog.open(ClientLeadProfileTaskCreateModalComponent, {
              hasBackdrop: true,
              disableClose: false,
              autoFocus: true,
              width: '500px',
              panelClass: 'cdk-overlay-panel-right-side',
              data: this.leadInfo
          });
          this.ClientLeadProfileTaskCreateModalComponent.afterClosed().subscribe(result => {
              if (result != undefined) {
                  // console.log("hi")
                  // this.showComponentLoader1 = true
                  let body = {
                      'lead_status': element.lead_status
                  }
                  this.serverService.updateLead(element, body, this.authToken).subscribe(
                      data => {
                          element.lead_status_new = element.lead_status;
                          this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
                      },
                      err => {
                          element.lead_status = element.lead_status_new;
                          this.clipBoardService.checkServerError(err, this.authToken)
                      }
                  )
                  // this.getProfileTasks()
              }
          })
      }

      else if (element.lead_status == "Appointment Proposed") {
          sessionStorage.setItem('lead_status_changed', 'true');
          localStorage.setItem('leadInfo', JSON.stringify(element));
          this.appointmentModalComponent = this.dialog.open(AppointmentModalComponent, {
              hasBackdrop: true,
              disableClose: false,
              autoFocus: true,
              width: '500px',
              panelClass: 'cdk-overlay-panel-right-side',
              data: element
          });
          this.appointmentModalComponent.afterClosed().subscribe(result => {
              if (result != undefined) {
                  delete result["status_description"]

                  // console.log(result)
                  if (this.userInfo.member_type == 'Vendor') {
                      element = result
                      element.vendor_remark = result.vendor_remark;
                      element.lead_status_new = element.lead_status;

                  }
                  else if (this.userInfo.member_type == 'Client') {
                      element = result;

                      element.client_remark = result.client_remark_new;
                      // element.vendor_remark = result.vendor_remark;
                      element.lead_status_new = element.lead_status;
                  }
                  this.serverService.updateLead(element, result, this.authToken).subscribe(
                      data => {

                          this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
                      },
                      err => {
                          element.lead_status = element.lead_status_new;
                          this.clipBoardService.checkServerError(err, this.authToken)
                      }
                  )
              } else {
                  element.lead_status = element.lead_status_new;
              }
          });
      }
      else {
          (<any>window).ga('send', 'event', {
              eventCategory: 'Projects',
              eventLabel: this.userInfo.email,
              eventAction: 'Lead Status - ' + element.lead_status
          });
          let body = {
              "lead_status": element.lead_status,
          }
          if (this.userInfo.member_type == "Vendor") {
              if (element.lead_status != "Verified" && element.lead_status != "Appointment Proposed") {
                  let arrayForm = ["Closed/Won", "Interested", "Not Interested", "Not Responding", "Not Available", "Contacted", "Follow Up", "Site Visit"]
                  if (arrayForm.includes(element.lead_status)) {
                      this.confirmLeadModalComponent = this.dialog.open(ConfirmLeadModalComponent, {
                          hasBackdrop: true,
                          disableClose: false,
                          autoFocus: true,
                          width: '500px',
                          panelClass: 'cdk-overlay-panel-right-side',
                          data: element
                      });
                      this.confirmLeadModalComponent.afterClosed().subscribe(result => {
                          if (result != undefined) {
                              this.serverService.updateLead(element, body, this.authToken).subscribe(
                                  data => {
                                      element.lead_status_new = element.lead_status;
                                      this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
                                  },
                                  err => {
                                      element.lead_status = element.lead_status_new;
                                      this.clipBoardService.checkServerError(err, this.authToken)
                                  }
                              )
                          }
                      });
                  } else {
                      if (element.lead_status == "V Not Interested") {
                          this.leadVndorUpdatedModalComponent = this.dialog.open(LeadVndorUpdatedModalComponent, {
                              hasBackdrop: true,
                              disableClose: false,
                              autoFocus: true,
                              width: '50vw',
                              panelClass: 'cdk-overlay-panel-right-side',
                              data: element
                          });
                          this.leadVndorUpdatedModalComponent.afterClosed().subscribe(result => {
                              if (result != undefined) {
                                  body["vendor_remark"] = result.trim()
                                  body["vendor_remark_new"] = result.trim();
                                  this.serverService.updateLead(element, body, this.authToken).subscribe(
                                      data => {
                                          element.lead_status_new = element.lead_status;
                                          element.vendor_remark = result
                                          element.vendor_remark_new = result
                                          this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
                                      },
                                      err => {
                                          element.lead_status = element.lead_status_new;
                                          this.clipBoardService.checkServerError(err, this.authToken)
                                      }
                                  )
                              } else {
                                  element.lead_status = element.lead_status_new;
                              }
                          })
                      } else {
                          this.serverService.updateLead(element, body, this.authToken).subscribe(
                              data => {
                                  element.lead_status_new = element.lead_status;
                                  this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
                              },
                              err => {
                                  element.lead_status = element.lead_status_new;
                                  this.clipBoardService.checkServerError(err, this.authToken)
                              }
                          )
                      }
                  }
              } else {
                  if (element.lead_status == "Appointment Proposed") {
                      this.appointmentModalComponent = this.dialog.open(AppointmentModalComponent, {
                          hasBackdrop: true,
                          disableClose: false,
                          autoFocus: true,
                          width: '500px',
                          panelClass: 'cdk-overlay-panel-right-side',
                          data: element
                      });
                      this.appointmentModalComponent.afterClosed().subscribe(result => {
                          if (result != undefined) {
                              delete result["status_description"]
                              this.serverService.updateLead(element, result, this.authToken).subscribe(
                                  data => {
                                      element = result
                                      element.lead_status_new = element.lead_status;
                                      this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
                                  },
                                  err => {
                                      element.lead_status = element.lead_status_new;
                                      this.clipBoardService.checkServerError(err, this.authToken)
                                  }
                              )
                          } else {
                              element.lead_status = element.lead_status_new;
                          }
                      });
                  } else {
                      this.leadUpdatedToVerifiedStatusModalComponent = this.dialog.open(LeadUpdatedToVerifiedStatusModalComponent, {
                          hasBackdrop: true,
                          disableClose: false,
                          autoFocus: true,
                          width: '50vw',
                          panelClass: 'cdk-overlay-panel-right-side',
                          data: element
                      });
                      this.leadUpdatedToVerifiedStatusModalComponent.afterClosed().subscribe(result => {
                          if (result != undefined) {
                              body["vendor_remark"] = result
                              body["vendor_remark_new"] = result
                              this.serverService.updateLead(element, body, this.authToken).subscribe(
                                  data => {
                                      element.lead_status_new = element.lead_status;
                                      element.vendor_remark = result
                                      element.vendor_remark_new = result
                                      this.clipBoardService.showMessgeInText("Lead Updated Succesfully", "success-snackbar")
                                  },
                                  err => {
                                      element.lead_status = element.lead_status_new;
                                      this.clipBoardService.checkServerError(err, this.authToken)
                                  }
                              )
                          } else {
                              element.lead_status = element.lead_status_new;
                          }
                      });
                  }
              }
          } else {
              let arrayForm = ["Not Interested", "Not Responding", "Not Available"]
              let arrayForm1 = ["Closed/Won", "Interested", "Follow Up", "Site Visit"]
              let arrayForm2 = ["Interested", "Closed/Won", "Contacted", "Site Visit", "Follow Up", "Not Interested"]
              var result = new Date(element.last_vendor_status_updated_at);
              result.setDate(result.getDate() + 2);
              if (Date.parse(result.toString()) < Date.now()) {
                  arrayForm1.push("Verified")
                  arrayForm1.push("Contacted")
              }
              if (arrayForm2.includes(element.lead_status)) {
                  element.member_type = 'Client'
                  this.clientRemarkModalComponent = this.dialog.open(ClientRemarkModalComponent, {
                      hasBackdrop: true,
                      disableClose: false,
                      autoFocus: true,
                      width: '500px',
                      panelClass: 'cdk-overlay-panel-right-side',
                      data: element
                  });
                  this.clientRemarkModalComponent.afterClosed().subscribe(result => {
                      if (result != undefined) {
                          delete element.member_type
                          element.client_remark = result.client_remark.trim()
                          body["client_remark"] = element.client_remark
                          body["status_description"] = result.status_description
                          this.serverService.updateLead(element, body, this.authToken).subscribe(
                              data => {
                                  element.client_remark_new = element.client_remark
                                  element.lead_status_new = element.lead_status;
                                  this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
                              },
                              err => {
                                  element.client_remark_new = result.client_remark_new
                                  element.lead_status = element.lead_status_new;
                                  this.clipBoardService.checkServerError(err, this.authToken)
                              }
                          )
                      } else {
                          element.lead_status = element.lead_status_new;
                      }
                  });
              } else if (arrayForm.includes(element.lead_status) && !arrayForm1.includes(element.lead_status_new)) {
                  this.confirmLeadModalComponent = this.dialog.open(ConfirmLeadModalComponent, {
                      hasBackdrop: true,
                      disableClose: false,
                      autoFocus: true,
                      width: '500px',
                      panelClass: 'cdk-overlay-panel-right-side',
                      data: element
                  });
                  this.confirmLeadModalComponent.afterClosed().subscribe(result => {
                      if (result != undefined) {
                          element.client_remark = result.trim()
                          element.client_remark_new = result.trim()
                          body["client_remark"] = element.client_remark
                          this.serverService.updateLead(element, body, this.authToken).subscribe(
                              data => {
                                  element.lead_status_new = element.lead_status;
                                  this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
                              },
                              err => {
                                  element.lead_status = element.lead_status_new;
                                  this.clipBoardService.checkServerError(err, this.authToken)
                              }
                          )
                      } else {
                          element.lead_status = element.lead_status_new;
                      }
                  });
              } else {
                  this.serverService.updateLead(element, body, this.authToken).subscribe(
                      data => {
                          element.lead_status_new = element.lead_status;
                          this.clipBoardService.showMessgeInText("Lead Updated Successfully", "success-snackbar")
                      },
                      err => {
                          element.lead_status = element.lead_status_new;
                          this.clipBoardService.checkServerError(err, this.authToken)
                      }
                  )
              }
          }
      }
      sessionStorage.setItem('lead_status_changed', 'false');

  }

}
